module.exports = __webpack_public_path__ + "img/apple.3147dc9c.svg";